import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PhotoAiEntryStyled } from "./photo-ai-entry.styled";
import { usePhotoAi } from "../hooks/photo-ai.hook";
import PhotoAiReferenceModal from "../photo-ai-reference-modal";
import PhotoAiResultsModal from "../photo-ai-results-modal";

const PhotoAiEntry: FC = () => {
  const { t } = useTranslation();
  const {
    isAvailable,
    step,
    images,
    reference,
    relatedUrls,
    selectedUrls,
    loading,
    adding,
    setReference,
    handleOpen,
    handleClose,
    handleConfirmReference,
    toggleUrl,
    handleAdd,
    handleAcquire,
    getPreviewSrc,
  } = usePhotoAi();

  if (!images.length) return null;

  return (
    <>
      <PhotoAiEntryStyled type="button" onClick={handleOpen}>
        {t("productComponent.product.photoAi.cta")}
      </PhotoAiEntryStyled>

      <PhotoAiReferenceModal
        open={step === "reference"}
        images={images}
        selected={reference}
        getPreviewSrc={getPreviewSrc}
        onSelect={setReference}
        onConfirm={handleConfirmReference}
        onClose={handleClose}
      />

      <PhotoAiResultsModal
        open={step === "results"}
        loading={loading}
        adding={adding}
        isAvailable={isAvailable}
        reference={reference}
        relatedUrls={relatedUrls}
        selectedUrls={selectedUrls}
        getPreviewSrc={getPreviewSrc}
        onToggle={toggleUrl}
        onAdd={handleAdd}
        onAcquire={handleAcquire}
        onClose={handleClose}
      />
    </>
  );
};

export default PhotoAiEntry;
